import React, { useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import DocumentMeta from 'core/components/DocumentMeta'
import Theme from 'core/themes/model'
import ListNodeGroups from './ListNodeGroups'
import ListWorkerNodes from './ListWorkerNodes'
import StatusCardsHeader from 'k8s/components/dashboard/StatusCardsHeader'

const ClusterCapacityAndHealth = () => {
  const classes = useStyles({})
  return (
    <>
      <DocumentMeta
        title="Capacity And Health Dashboard"
        data-testid="capacity-and-health-document-meta"
        breadcrumbs
      />
      <div className={classes.customGridContainer} data-testid="capacity-and-health-grid-container">
        <StatusCardsHeader data-testid="capacity-and-health-status-cards-header" />
        <ListNodeGroups data-testid="capacity-and-health-list-node-groups" />
        <ListWorkerNodes data-testid="capacity-and-health-list-worker-nodes" />
      </div>
    </>
  )
}

export default ClusterCapacityAndHealth

const useStyles = makeStyles((theme: Theme) => ({
  customGridContainer: {
    display: 'grid',
    gap: '16px',
  },
}))
